<template>
  <b-container class="container-field">
    <b-row>
      <b-table-simple hover small caption-top responsive>
        <b-thead>
          <b-tr>
            <!-- {{stage}} -->
            <b-th v-for="field in fieldsCampos" :key="field.key">
              <div v-if="stage == false">
                {{ field.label }}
              </div>
              <div v-else>
                <div v-if="field.label != 'Chave única'">{{ field.label }}</div>
              </div>
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <template v-for="row in fillActiveList">
            <!-- {{ row.field }} -->
            <!-- {{ row.field.sequenceNumber }} -->
            <b-tr :key="row.field.sequenceNumber">
              <b-td> {{ row.field.sequenceNumber }} </b-td>
              <b-td>
                <b-form-input
                  class="input-name"
                  type="text"
                  v-model="row.field.displayName"
                  required
                />
                <!-- <span class="text-danger" v-if="modelstate['DisplayName']">
                  {{ modelstate["DisplayName"][0] }}
                </span> -->
              </b-td>
              <b-td>
                <b-form-select
                  class="select-field"
                  :options="options"
                  v-model="row.field.type"
                  @change="(newValue) => onTypeChanged(newValue, row.field)"
                ></b-form-select>
              </b-td>
              <b-td>
                <b-form-select
                  v-if="row.field.type == 10 || row.field.type == 11"
                  id="isMandatoryAttachment"
                  class="select-boolean"
                  :options="optionsBoolean"
                  v-model="row.field.isMandatoryAttachment"
                ></b-form-select>
                <b-form-select
                  v-else-if="requiredField(row.field.type)"
                  class="select-field"
                  :options="optionsBoolean"
                  v-model="row.field.required"
                ></b-form-select>
              </b-td>
              <!-- ivan 20220812
               <b-td>
                <b-form-select
                  v-if="visibilityField(row.field.type)"
                  class="select-field"
                  :options="optionsBoolean"
                  v-model="row.field.visibility"
                ></b-form-select>
              </b-td> -->
              <!-- {{ stage }} -->
              <b-td>
                <b-form-select
                  v-if="uniqueKeyField(row.field.type) && stage == false"
                  class="select-field"
                  :options="optionsBoolean"
                  v-model="row.field.uniqueKey"
                ></b-form-select>
              </b-td>
              <b-td>
                <b-form-input
                  v-if="tipField(row.field.type)"
                  class="input-name"
                  type="text"
                  v-model="row.field.tip"
                  required
                />
              </b-td>
              <b-td style="min-width: 250px">
                <workflow-table-resequence
                  class="d-inline"
                  :item="row.field"
                  :items="fields"
                  :display-name="row.field.displayName"
                  :title="$t('checklist.form.fieldResequence')"
                  v-b-tooltip.hover
                ></workflow-table-resequence>
                <b-button
                  class="ml-1"
                  size="sm"
                  :title="$t('checklist.form.fieldDelete')"
                  v-b-tooltip.hover
                  @click="deleteField(row)"
                >
                  X
                </b-button>
                <b-button
                  size="sm"
                  class="ml-1"
                  :title="$t('checklist.form.fieldClone')"
                  v-b-tooltip.hover
                  @click="cloneField(row.field, fields)"
                >
                  <i class="tim-icons icon-single-copy-04"></i>
                </b-button>
                <b-button
                  size="sm"
                  class="ml-1"
                  :title="$t('checklist.form.fieldConfigShow')"
                  v-b-tooltip.hover
                  @click="displayConfig(row)"
                >
                  <i class="tim-icons icon-settings-gear-63"></i>
                </b-button>
                <!-- {{row.field.type}} -->
                <b-button
                  :disabled="row.field.type != 7 && row.field.type != 13"
                  size="sm"
                  class="ml-1"
                  :title="$t('checklist.form.fieldValuesShow')"
                  v-b-tooltip.hover
                  @click="row.detailsShowing = !row.detailsShowing"
                >
                  <i
                    v-if="row.detailsShowing"
                    class="tim-icons icon-simple-delete"
                  ></i>
                  <i v-else class="tim-icons icon-simple-add"></i>
                </b-button>
              </b-td>
              <!-- ivan 20220812
              <b-td>
                <b-form-checkbox
                  v-if="summaryField(row.field.type)"
                  switch
                  class="mr-n2"
                  v-model="row.field.summaryField"
                >
                  <i
                    v-if="row.field.summaryField"
                    class="tim-icons icon-check-2"
                  ></i>
                </b-form-checkbox>
              </b-td> -->
            </b-tr>
            <b-tr
              class="b-table-details"
              v-if="row.field.type == 8"
              :key="row.field.sequenceNumber"
            >
              <b-td :colspan="fieldsCampos.length">
                <b-form-textarea
                  v-model="row.field.defaultValue"
                  style="height: 10rem"
                ></b-form-textarea>
              </b-td>
            </b-tr>
            <b-tr
              class="b-table-details"
              v-if="row.configShowing"
              :key="row.field.sequenceNumber"
            >
              <b-td :colspan="fieldsCampos.length">
                <b-card>
                  <b-row>
                    <b-col cols="6">
                      <div v-if="row.field.type == 14">
                        <b-form-group
                          label="Perfil responsável"
                          label-for="permiteAnexo"
                        >
                          <multiselect
                            id="selectSteps"
                            class="select-field"
                            v-model="row.field.responsibles"
                            label="text"
                            track-by="value"
                            placeholder="Selecione os perfis"
                            :close-on-select="false"
                            :showLabels="false"
                            :multiple="true"
                            :options="profileOptions"
                          >
                          </multiselect>
                        </b-form-group>
                      </div>
                      <div v-if="row.field.type == 20">
                        <b-form-group
                          label="Tipo de veículo"
                          label-for="VehicleType"
                        >
                          <multiselect
                            id="selectSteps"
                            class="select-field"
                            v-model="row.field.vehicles"
                            label="text"
                            track-by="value"
                            placeholder="Selecione os perfis"
                            :close-on-select="false"
                            :showLabels="false"
                            :multiple="true"
                            :options="vehicleOptions"
                          >
                          </multiselect>
                        </b-form-group>
                      </div>
                      <div v-else-if="row.field.type == 19">
                        <!-- <div>{{ row.field }}</div> -->
                        <b-form-group label="Campo placa do veículo">
                          <b-form-select
                            :options="fieldActiveOptionsList"
                            v-model="
                              row.field.tripPlanFields.vehiclePlateFieldId
                            "
                          ></b-form-select>
                        </b-form-group>

                        <b-form-group label="Campo motorista">
                          <b-form-select
                            :options="fieldActiveOptionsList"
                            v-model="row.field.tripPlanFields.driverFieldId"
                          ></b-form-select>
                        </b-form-group>

                        <b-form-group label="Campo data de inicio">
                          <b-form-select
                            :options="fieldActiveOptionsList"
                            v-model="row.field.tripPlanFields.dateBeginFieldId"
                          ></b-form-select>
                        </b-form-group>

                        <b-form-group label="Campo hora de inicio">
                          <b-form-select
                            :options="fieldActiveOptionsList"
                            v-model="row.field.tripPlanFields.hourBeginFieldId"
                          ></b-form-select>
                        </b-form-group>

                        <b-form-group label="Campo data de fim">
                          <b-form-select
                            :options="fieldActiveOptionsList"
                            v-model="row.field.tripPlanFields.dateEndFieldId"
                          ></b-form-select>
                        </b-form-group>

                        <b-form-group label="Campo hora de fim">
                          <b-form-select
                            :options="fieldActiveOptionsList"
                            v-model="row.field.tripPlanFields.hourEndFieldId"
                          ></b-form-select>
                        </b-form-group>

                        <b-form-group label="Campo origem">
                          <b-form-select
                            :options="fieldActiveOptionsList"
                            v-model="row.field.tripPlanFields.originFieldId"
                          ></b-form-select>
                        </b-form-group>

                        <b-form-group label="Campo destino">
                          <b-form-select
                            :options="fieldActiveOptionsList"
                            v-model="row.field.tripPlanFields.destinyFieldId"
                          ></b-form-select>
                        </b-form-group>
                        <b-form-group label="Campo documento">
                          <b-form-select
                            :options="fieldActiveOptionsList"
                            v-model="row.field.tripPlanFields.documentFieldId"
                          ></b-form-select>
                        </b-form-group>
                        <b-form-group label="Campo CTE">
                          <b-form-select
                            :options="fieldActiveOptionsList"
                            v-model="row.field.tripPlanFields.cteFieldId"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <!-- {{row.field.type}} -->
                    <b-col sm="12" md="2">
                      <b-form-group
                        v-if="row.field.type != 10 && row.field.type != 11"
                        label="Permite anexo"
                        label-for="permiteAnexo"
                      >
                        <b-form-select
                          id="permiteAnexo"
                          :options="optionsBoolean"
                          v-model="row.field.allowAttachment"
                        ></b-form-select>
                      </b-form-group>
                    </b-col>
                    <!-- {{ row.field }} -->
                    <b-col v-if="row.field.allowAttachment" sm="12" md="2">
                      <b-form-group
                        v-if="row.field.type != 10 && row.field.type != 11"
                        label="Anexo obrigatório"
                        label-for="permiteAnexo"
                      >
                        <b-form-select
                          id="isMandatoryAttachment"
                          class="select-boolean"
                          :options="optionsBoolean"
                          v-model="row.field.isMandatoryAttachment"
                        >
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <div v-if="canShowPostCalculateScript(row.field)">
                    <b-form-group
                      label="Script cálculo pós processamento"
                      label-for="PostCalculationScript"
                    >
                      <custom-codemirror
                        id="PostCalculationScript"
                        :model.sync="row.field.postCalculationScript"
                        :readonly="true"
                      />
                    </b-form-group>
                  </div>
                </b-card>
              </b-td>
            </b-tr>
            <b-tr
              class="b-table-details"
              v-if="row.detailsShowing"
              :key="row.field.sequenceNumber"
            >
              <b-td :colspan="fieldsCampos.length">
                <b-card>
                  <div
                    v-if="row.field.type == 7 || row.field.type == 13"
                    class="mt-4"
                  >
                    <h4>
                      {{ $t("checklist.form.fieldValues") }}:
                      {{ row.field.displayName }}
                    </h4>
                    <workflow-table-value
                      ref="ProcessTableValue"
                      :values="row.field.values"
                      :allow-add-fields="true"
                      :fieldType="row.field.type"
                      :stage="stage"
                    >
                    </workflow-table-value>
                  </div>
                </b-card>
              </b-td>
            </b-tr>
          </template>
        </b-tbody>
      </b-table-simple>

      <b-button size="sm" @click="addFields">
        {{ $t("workflow.processField.addField") }}
      </b-button></b-row
    >
    <!-- {{ fields }} -->
    <!-- {{ tableRows }} -->
    <!-- <div>{{ fillActiveList }}</div> -->
    <!-- <div>{{ fieldActiveOptionsList }}</div> -->
  </b-container>
</template>
<script>
import FieldSequenceControl from "./FieldSequenceControl";
import WorkflowCloneField from "./WorkflowCloneField";
import CustomCodemirror from "@/components_rms/checklist/form/CustomCodemirror.vue";
export default {
  name: "WorkflowField",
  props: {
    fields: Array,
    allowAddFields: Boolean,
    modelstate: Object,
    stage: Boolean,
  },
  components: {
    WorkflowTableResequence: () => import("./WorkflowTableResequence.vue"),
    WorkflowTableValue: () => import("./WorkflowTableValue.vue"),
    CustomCodemirror,
  },
  mixins: [FieldSequenceControl, WorkflowCloneField],
  data() {
    return {
      tableRows: [],
      fieldsCampos: [
        {
          label: "Id",
          key: "sequenceNumber",
          sortable: false,
        },
        {
          label: "Nome",
          key: "displayName",
          sortable: false,
        },
        {
          label: "Tipo",
          key: "type",
          sortable: false,
        },
        {
          label: "Obrigatório",
          key: "required",
          sortable: false,
        },
        // ivan 20220812
        // {
        //   label: "Visibilidade",
        //   key: "visibility",
        //   sortable: false,
        // },
        {
          label: "Chave única",
          key: "uniqueKey",
          sortable: false,
        },
        {
          label: "Dica",
          key: "tip",
          sortable: false,
        },
        {
          key: "actions",
          label: "",
        },
        // ivan 20220812
        // {
        //   label: "Campo de resumo",
        //   key: "summaryField",
        //   sortable: false,
        // },
      ],
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      options: [{ value: null, text: "Tipo", value: 7, text: "Lista" }],
      profileOptions: [],
      vehicleOptions: [],
    };
  },
  mounted: function () {
    this.loadTableRows();
  },
  created() {
    this.getFieldOptions();
    this.getAllProfileOptions();
    this.getAllVehicleType();
  },
  computed: {
    fillActiveList() {
      let camposAtivos = [];
      for (let campo of this.tableRows) {
        if (campo.field.active) {
          camposAtivos.push(campo);
        }
      }
      return camposAtivos.sort(
        (c1, c2) => c1.field.sequenceNumber - c2.field.sequenceNumber
      );
    },
    fieldActiveOptionsList() {
      let opcoes = [];
      for (let row of this.fillActiveList) {
        console.log("row.field");
        console.log(row.field);
        opcoes.push({ value: row.field.id, text: row.field.displayName });
      }
      return opcoes;
    },
  },
  methods: {
    getAllProfileOptions() {
      this.$apiScheduler.get("/profile/getAll/").then((response) => {
        console.log(response);
        this.profileOptions = response.data;
      });
    },
    getAllVehicleType() {
      this.$apiVehicle.get("/vehicleType/getDropdown/").then((response) => {
        // console.log(response);
        this.vehicleOptions = response.data;
      });
    },
    uniqueKeyField(field) {
      if (field == 1) return false;
      if (field == 8) return false;
      if (field == 9) return false;
      if (field == 10) return false;
      if (field == 11) return false;
      if (field == 12) return false;
      if (field == 13) return false;
      return true;
    },
    tipField(field) {
      if (field == 1) return false;
      if (field == 8) return false;
      if (field == 9) return false;
      if (field == 10) return false;
      if (field == 11) return false;
      if (field == 12) return false;
      if (field == 13) return false;
      return true;
    },
    // ivan 20220812
    // visibilityField(field) {
    //   if (field == 8) return false;
    //   if (field == 9) return false;
    //   if (field == 10) return false;
    //   if (field == 11) return false;
    //   if (field == 12) return false;
    //   return true;
    // },
    requiredField(field) {
      if (field == 8) return false;
      if (field == 9) return false;
      return true;
    },
    // ivan 20220812
    // summaryField(field) {
    //   if (field == 8) return false;
    //   if (field == 9) return false;
    //   if (field == 10) return false;
    //   if (field == 11) return false;
    //   if (field == 12) return false;
    //   return true;
    // },
    addTableRow(field) {
      this.tableRows.push({
        configShowing: false,
        detailsShowing: false,
        field: field,
      });
    },

    addFields() {
      let field = {
        id: this.generateUUID(),
        displayName: "",
        tip: "",
        visibility: false,
        uniqueKey: false,
        type: 6,
        required: false,
        active: true,
        sequenceNumber: this.getNextSequenceNumber(this.fields),
        values: [],
        allowAttachment: false,
        isMandatoryAttachment: false,
        summaryField: false,
        dateCreate: new Date(),
        responsibles: [],
        vehicles: [],
      };
      this.fields.push(field);
      this.addTableRow(field);
      this.$forceUpdate();
    },
    loadTableRows() {
      this.tableRows = [];
      if (this.fields) {
        if (this.fields.length > 0) {
          this.fields.forEach((field) => {
            this.addTableRow(field);
          });
        }
      }
      this.$forceUpdate();
    },
    cloneField(campoBase, listaCampos) {
      this.copyField(campoBase, listaCampos);
      this.$forceUpdate();
    },
    deleteField(row) {
      console.log(row);
      if (!row.field.id || row.field.id == 0) {
        let rowIndex = this.tableRows.indexOf(row);
        if (rowIndex >= 0) {
          this.tableRows.splice(rowIndex, 1);
        }

        let itemIndex = this.fields.indexOf(row.field);
        if (itemIndex >= 0) {
          this.fields.splice(itemIndex, 1);
        }
      } else {
        row.field.active = false;
      }
      // reordenação da sequenciaExibicao apos remover o campo
      let campos = this.fillActiveList;
      for (let i = 0; i < campos.length; i++) {
        campos[i].field.sequenceNumber = i + 1;
      }
    },
    displayConfig(row) {
      if (row) {
        row.configShowing = !row.configShowing;
        this.$forceUpdate();
      }
    },
    canShowAttachmentOption(field) {
      switch (field.type) {
        case 8:
          return false;
      }
      return true;
    },
    getFieldOptions() {
      this.$apiWorkflow.get("/workflow/fieldType/").then((response) => {
        // console.log(response.data);
        this.options = response.data;
      });
    },
    onTypeChanged(newValue, field) {
      console.log(`onTypeChanged ${newValue}`);
      if (newValue == 19) {
        if (!field.tripPlanFields) {
          field.tripPlanFields = {
            dateBeginFieldId: null,
            dateEndFieldId: null,
            driverFieldId: null,
            hourBeginFieldId: null,
            hourEndFieldId: null,
            tripPlanFieldId: field.id,
            vehiclePlateFieldId: null,
            originFieldId: null,
            destinyFieldId: null,
          };
        }
      }
    },
    canShowPostCalculateScript(field) {
      switch (field.type) {
        case 9:
          return true;
      }
      return false;
    },
  },

  watch: {
    fields() {
      this.loadTableRows();
    },
  },
};
</script>
